import { useMouseIdle } from "../hooks/useMouseIdle";

/**
 * KioskIdleOverlay — iter329 shared screensaver overlay for Roster,
 * Tardies, and Open Shifts fullscreen. After 5 minutes of no user
 * activity a large soft dimmer covers the page with a "TAP TO WAKE"
 * hint; any mouse/keyboard/touch event dismisses it via `useMouseIdle`.
 *
 * Kept intentionally lightweight so it can drop into any fullscreen
 * route without wiring extra state.
 */
export function KioskIdleOverlay({ enabled = true, label = "Iris Live Ops" }) {
  const idle = useMouseIdle({ delayMs: 5 * 60 * 1000, disabled: !enabled });
  if (!idle) return null;
  return (
    <div
      data-testid="kiosk-idle-overlay"
      className="fixed inset-0 z-40 pointer-events-none flex items-center justify-center"
      style={{
        background:
          "radial-gradient(ellipse at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.85) 60%, rgba(0,0,0,0.95) 100%)",
      }}
    >
      <div className="text-center animate-pulse">
        <div className="font-display font-black uppercase tracking-widest text-4xl md:text-6xl text-[#FF3B30] drop-shadow-[0_0_20px_rgba(255,59,48,0.4)]">
          {label}
        </div>
        <div className="mt-3 text-xs md:text-sm uppercase tracking-widest text-zinc-500">
          Tap or move mouse to wake
        </div>
      </div>
    </div>
  );
}
